import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Layout, MinusPlusButtons, OverlayPopover, Pill } from '@utilities';

import styles from './_index.module.scss';

const MaxAnswers = ({ question, setMaxAnswers }) => {
  const [answersCount, setAnswersCount] = useState(1);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const maxSelectedAnswers = question.answers.length + (question.noneAnswer ? 1 : 0);
  const pillRef = useRef();

  useEffect(() => {
    setAnswersCount(question.properties?.maxAnswers || 1);
  }, [isPopoverOpen]);

  const handleApply = () => {
    setMaxAnswers(answersCount);
    setIsPopoverOpen(false);
  };
  const handleClear = () => {
    setMaxAnswers(undefined);
    setIsPopoverOpen(false);
  };

  return (
    <>
      <Layout.Flex className={styles['max-answers']} gap="x-small">
        Max Answers
        <Pill
          buttonRef={pillRef}
          data-testid="max-answers-pill"
          isModified={!!question.properties?.maxAnswers}
          onClick={() => setIsPopoverOpen(!isPopoverOpen)}
          onClose={handleClear}
          value={question.properties?.maxAnswers || 'Any Number'}
        />
      </Layout.Flex>
      <OverlayPopover
        className={styles['max-answers-popover']}
        data-testid="max-answers-popover"
        hasArrow
        isActive={isPopoverOpen}
        onHide={() => setIsPopoverOpen(false)}
        target={pillRef.current}
      >
        <Layout.Flex gap="x-small">
          <Layout.Fill>Max Answers</Layout.Fill>
          <strong>{answersCount}</strong>
          <MinusPlusButtons
            disableMinusButton={answersCount <= 1}
            disablePlusButton={answersCount >= maxSelectedAnswers}
            onClickMinus={() => setAnswersCount((prev) => prev - 1)}
            onClickPlus={() => setAnswersCount((prev) => prev + 1)}
          />
        </Layout.Flex>
        <Button onClick={handleApply} text="Apply" />
      </OverlayPopover>
    </>
  );
};

MaxAnswers.propTypes = {
  question: PropTypes.object.isRequired,
  setMaxAnswers: PropTypes.func.isRequired,
};

export default MaxAnswers;
